import { StandardEvents } from '@shopify/events';
import '@theme/product-form';

const pending = new Map();

window.addEventListener('submit', event => {
  const component = event.target.closest?.('[data-tea-pairing]');
  if (!component) return;
  const variant = component.querySelector('[name="id"]')?.value;
  if (!variant) return;
  if (pending.has(variant)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  pending.set(variant, { component, focus: document.activeElement });
}, true);

document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const component = event.target.closest?.('[data-tea-pairing]');
  if (!component) return;
  const variant = component.querySelector('[name="id"]')?.value;
  const action = pending.get(variant);
  if (!action) return;
  const scope = component.closest('dialog') || document.querySelector('main') || document;
  for (const peer of document.querySelectorAll('[data-tea-pairing]')) {
    if (peer.querySelector('[name="id"]')?.value === variant) {
      peer.setAttribute('aria-busy', 'true');
      const button = peer.querySelector('button[name="add"]');
      if (button) button.disabled = true;
    }
  }
  Promise.resolve(event.promise).catch(() => {}).finally(() => {
    pending.delete(variant);
    for (const peer of document.querySelectorAll('[data-tea-pairing]')) {
      if (peer.querySelector('[name="id"]')?.value === variant) {
        peer.removeAttribute('aria-busy');
        const button = peer.querySelector('button[name="add"]');
        if (button) button.disabled = false;
      }
    }
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (action.focus?.isConnected && action.focus.checkVisibility()) return;
      const focused = document.activeElement;
      if (focused !== document.body && focused !== scope && focused?.checkVisibility()) return;
      const next = scope.querySelector('[data-tea-pairing] button[name="add"]:not(:disabled)') || scope.querySelector('[name="checkout"]');
      next?.focus({ preventScroll: true });
    }));
  });
});

